import {createSlice} from '@reduxjs/toolkit';
import type {IWikiFormatterProps} from '@yandex-int/tools-components/WikiFormatter';

import {ExperimentKey} from '~ui/../shared/constants';

export interface GlobalState {
    staffHost?: string;
    trackerHost: string;
    avatarsHost: string;
    collabUrl: string;
    wfSettings: IWikiFormatterProps['settings'];
    isTouch?: boolean;
    appInstallation: 'intranet' | 'business';
    experiments: Partial<Record<ExperimentKey, boolean>>;
    forceDesktop?: boolean;
}

const initialState: GlobalState = {
    trackerHost: '',
    avatarsHost: '',
    wfSettings: {},
    appInstallation: 'intranet',
    experiments: {},
    collabUrl: '',
};

export const {reducer} = createSlice({
    name: 'global',
    initialState,
    reducers: {},
});
